import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'delete-confirmation-modal',
    templateUrl: './delete-confirmation.modal.html',
    styleUrls: ['./delete-confirmation.modal.scss'],
})
export class DeleteConfirmationModal {
    @Input() title: string[];

    constructor(public activeModal: NgbActiveModal) {
    }

    
}